export const BACK_TO_SCHOOL_PREVIEW_CAMPAIGN_ID = "back-to-school-2026";
export const BACK_TO_SCHOOL_PREVIEW_PATH = "/back-to-school-preview";
export const BACK_TO_SCHOOL_PREVIEW_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

// September 30, 2026 at 11:59:59.999 p.m. America/New_York.
// Stored as an absolute UTC timestamp so eligibility does not depend on client locale.
export const BACK_TO_SCHOOL_PREVIEW_CLAIM_DEADLINE_MS = Date.parse("2026-10-01T03:59:59.999Z");

export function isBackToSchoolPreviewCampaignClaimable(now = new Date()) {
  if (BACK_TO_SCHOOL_PREVIEW_CLAIM_DEADLINE_MS == null) {
    return false;
  }

  const nowDate = now instanceof Date ? now : new Date(now);
  return !Number.isNaN(nowDate.getTime())
    && nowDate.getTime() <= BACK_TO_SCHOOL_PREVIEW_CLAIM_DEADLINE_MS;
}
